<template>
  <b-card :class="cardClass">
    <h6 style="text-transform: uppercase; font-weight: 100;"><small>{{ cardTitle }}</small></h6>
    <number-animation
      ref="number1"
    	:from="0"
    	:to="to"
    	:format="theFormat"
    	:duration="2"
      :delay="0"
      easing="Power1.easeOut"
      class="h1"
      @complete="completed"
    /><span v-if="total" class="h2" v-translate="{total: total}">/%{total}<small><small> (total)</small></small></span>
  </b-card>
</template>

<script>
import NumberAnimation from '@/components/NumberAnimation.vue'

export default {
  components: {
    NumberAnimation
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'all'
    },
    cardClass: {
      type: String,
      default: ''
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 30
    },
    startDate: {
      type: String,
      default: ''
    },
    withTotal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cardTitle: '',
      to: 0,
      total: null,
      currentShippings: null,
      interval: null
    }
  },
  computed: {
    listConfig() {
      const { type } = this
      const filters = {
        includes: ['status_history', 'shipping_type'],
        page: 0,
        limit: 500
      }

      filters.filter_groups = []
      if (this.type === 'ongoing') {
        filters.filter_groups = [{
          'filters': [{
            'key': 'status',
            'value': ['CONFIRMED', 'TOBERETURNED', 'INTRANSIT', 'WAITING', 'ATPICKUPPOINT'],
            'operator': 'in'
          },
          {
            'key': 'fields_revision',
            'value': 0,
            'operator': 'eq'
          }]
        }]
      }
      if (this.type === 'history') {
        filters.filter_groups = [{
          'filters': [{
            'key': 'status',
            'value': ['DELIVERED', 'RETURNED', 'CANCELED'],
            'operator': 'in'
          }]
        }]
      }
      if (this.type === 'scheduled') {
        filters.filter_groups = [{
          'filters': [{
            'key': 'status',
            'value': 'WAITING',
            'operator': 'eq'
          },
          {
            'key': 'scheduled_date',
            'value': this.moment().utc().format('YYYY-MM-DD HH:mm:ss'),
            'operator': 'gt'
          }]
        }]
      }
      if (this.type === 'drafts') {
        filters.filter_groups = [{
          'filters': [{
            'key': 'status',
            'value': 'DRAFT',
            'operator': 'eq'
          }]
        }]
      }
      if (this.type === 'ready') {
        filters.filter_groups = [{
          'filters': [{
            'key': 'status',
            'value': 'READY',
            'operator': 'eq'
          }]
        }]
      }
      if (this.type === 'incidences') {
        filters.filter_groups = [{
          'filters': [{
            'key': 'status',
            'value': 'INCIDENCE',
            'operator': 'eq'
          }]
        }]
      }
      if (this.type === 'toreview') {
        filters.filter_groups = [{
          'filters': [{
            'key': 'fields_revision',
            'value': 1,
            'operator': 'eq'
          },
          {
            'key': 'status',
            'value': ['DRAFT', 'READY', 'WAITING'],
            'operator': 'in'
          }]
        }]
      }
      if (this.type === 'delivered') {
        filters.filter_groups = [{
          'filters': [{
            'key': 'status',
            'value': 'DELIVERED',
            'operator': 'eq'
          }]
        }]
      }
      filters.filter_groups.push({filters: [
        ['updated_at', 'gte', this.moment(this.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')],
        ['updated_at', 'lte', this.moment(this.startDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
      ]})

      return {
        type,
        filters
      }
    }
  },
  watch: {
    startDate(val) {
      this.listConfig.filters.filter_groups.pop()
      this.listConfig.filters.filter_groups.push({filters: [
        ['updated_at', 'gte', this.moment(val).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')],
        ['updated_at', 'lte', this.moment(val).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
      ]})
      this.fetchShippings()
    }
  },
  mounted() {
    this.fetchShippings()
    this.interval = setInterval(function () {
      this.fetchShippings()
    }.bind(this), (2 * 60 * 1000))
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    fetchShippings() {
      switch (this.$options.propsData.type) {
        case 'drafts':
          this.cardTitle = this.$gettext('Received by the system')
          break
        case 'ready':
          this.cardTitle = this.$gettext('Ready to be scheduled')
          break
        case 'ongoing':
          this.cardTitle = this.$gettext('Ongoing Shippings')
          break
        case 'scheduled':
          this.cardTitle = this.$gettext('Scheduled Shippings')
          break
        case 'history':
          this.cardTitle = this.$gettext('Shippings History')
          break
        case 'incidences':
          this.cardTitle = this.$gettext('Shippings With Incidences')
          break
        case 'toreview':
          this.cardTitle = this.$gettext('To be reviewed')
          break
        case 'delivered':
          this.cardTitle = this.$gettext('Shipping delivered')
          break
      }

      this.currentShippings = []
      // don't use store bc of memory leaks (// TODO: check it out)
      this.$http.get(this.$appConfig.api.baseUrl + 'users/' + this.$store.state.auth.uid + '/shippings', {params: this.listConfig.filters})
        .then(response => {
          this.shippings = response.body.data
          this.to = response.body.pagination.total

          if (this.withTotal) {
            let params = JSON.parse(JSON.stringify(this.listConfig.filters))
            delete params.filter_groups[1]
            params.limit = 1
            this.$http.get(this.$appConfig.api.baseUrl + 'users/' + this.$store.state.auth.uid + '/shippings', {params: params})
              .then(response => {
                this.total = response.body.pagination.total
              })
          }
          if (this.currentShippings !== JSON.stringify(this.shippings)) {
            this.currentShippings = JSON.stringify(this.shippings)
            this.$emit('updated', {type: this.type, shippings: this.shippings})
          }
        })
    },
    completed() {
      this.$emit('completed', true)
    },
    theFormat(number) {
      return number.toFixed(0)
    }
  }
}
</script>
